import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { BuProvider } from './Header';
import ChatDrawer from '../chat/ChatDrawer';

export default function Layout() {
  return (
    <BuProvider>
      <div style={styles.shell}>
        <Sidebar />
        <div style={styles.main}>
          <Outlet />
        </div>
        <ChatDrawer />
      </div>
    </BuProvider>
  );
}

const styles = {
  shell: { display: 'flex', minHeight: '100vh', background: '#f8fafc' },
  main: { flex: 1, overflow: 'auto' },
};
